export default __webpack_public_path__ + "static/media/Swift_mob@2x.d0d2fd84.png";